import styled from 'styled-components';

export const LoaderStyled = styled.div`
	left: 50%;
	top: 50%;
	position: fixed;
	z-index: 999999 !important;
	background-color: rgba(255, 255, 255, 0.8);
`;
